/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React, { useCallback } from 'react';
import { Modal, TouchableWithoutFeedback, View, ViewStyle } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import MenuView from './MenuView';
import { ListViewProps } from '@airasia-phoenix/react-native/components/ListView';
import { pd } from '../../utils';

export interface MenuModalProps {
  visible: boolean;
  onClose: () => void;
  testID?: string;
  containerWidth?: number;
  listViewItems: ListViewProps[];
  overlayColor?: string;
  positionStyle?: ViewStyle;
}

const MenuModal: React.FC<MenuModalProps> = ({
  visible,
  onClose,
  testID,
  containerWidth,
  listViewItems,
  overlayColor = pd.sys.colour.container_low.withAlpha(0).toString(),
  positionStyle,
}) => {
  const handleOutsidePress = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Modal
      transparent={true}
      visible={visible}
      animationType="none"
      onRequestClose={onClose}
    >
      <TouchableWithoutFeedback onPress={handleOutsidePress}>
        <View style={[styles.overlay, { backgroundColor: overlayColor }]}>
          <View style={positionStyle}>
            <MenuView
              testID={testID}
              containerWidth={containerWidth}
              listViewItems={listViewItems}
            />
          </View>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default MenuModal;
